import React, {useState, FormEvent, useContext} from "react"
import {useMutation} from "@apollo/client"
import {Search} from "../Tmdb/Search"

import MUTATION_COLLECTION_ADD from "graphql/Media/Collection/mutation/collectionAdd"
import {alertContext} from "context/Alert/alert"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"

export const CollectionAdd = (props: any) => {


  const [mutate] = useMutation(MUTATION_COLLECTION_ADD)

  const {setMessage, setError} = useContext(alertContext)

  const [collectionName, updateCollectionName] = useState("")
  const [collectionTmdbOptions, updateTmdbOptions] = useState(null)

  const onChange = (name: string, tmdbOptions: any) => {
    updateCollectionName(name)
    updateTmdbOptions(tmdbOptions)
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    mutate({
      variables: {
        input: {
          name: collectionName,
          tmdbOptions: collectionTmdbOptions
        }
      }
    })
      .then(() => {
        setMessage("Collection ajoutée au catalogue")
      })
      .catch(() => {
        setError("Impossible d'ajouter cette collection")
      })
  }

  return <BackofficePage eyebrow="Catalogue" title="Ajouter une collection" description="Créez un regroupement de films à partir des données TMDB." icon="fa-layer-group">
    <BackofficePanel title="Recherche TMDB" description="Sélectionnez la collection officielle à importer." icon="fa-search">
      <form className="bo-media-create-form" onSubmit={onSubmit}>
        <div className="bo-form-column">
          <Search
            type='collection'
            onChange={onChange}
          />
          {collectionName && <div className="bo-selection-confirmation"><span className="fas fa-check"></span><span><small>Collection sélectionnée</small><strong>{collectionName}</strong></span></div>}
          <button className="bo-primary-action" disabled={!collectionName}><span className="fas fa-plus"></span>Ajouter la collection</button>
        </div>
      </form>
    </BackofficePanel>
  </BackofficePage>
}
